import { BlockStack, Box, Icon, InlineStack, ProgressBar, Text } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';
import { getRequest } from '../../../shared/components/functions';
import { useParams } from 'react-router-dom';
import { ReceiptCard } from './ReceiptCard';
import Toasts from '../../../shared/components/toasts/toasts';
import { CheckCircleIcon } from '@shopify/polaris-icons';

export const OpenExpenses = () => {
  let { userId } = useParams();
  const [expenses, setExpenses] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const fetchData = useCallback(async () => {
    const data = await getRequest(`/api/expenses/users/${userId}/open`);
    setExpenses(data);
    setTotalCount(data.length);
    setLoaded(true);
  }, [userId]);

  useEffect(() => {
    if (userId) fetchData();
  }, [userId, fetchData]);

  const handleNext = () => {
    setExpenses((prev) => prev.slice(1));
  };

  if (!loaded) {
    return (
      <Box padding="800">
        <InlineStack align="center">
          <div className="expense-loader" />
        </InlineStack>
      </Box>
    );
  }

  if (loaded && expenses.length === 0) {
    return (
      <Box padding="800">
        <BlockStack gap="400" align="center" inlineAlign="center">
          <div style={{ color: '#22AB38' }}>
            <Icon source={CheckCircleIcon} tone="success" />
          </div>
          <Text variant="headingLg" as="h2" alignment="center">
            All done!
          </Text>
          <Text variant="bodyMd" tone="subdued" alignment="center">
            No expenses are awaiting your approval
          </Text>
        </BlockStack>
      </Box>
    );
  }

  const processed = totalCount - expenses.length;
  const progress = totalCount > 0 ? (processed / totalCount) * 100 : 0;

  return (
    <BlockStack gap="600">
      <Toasts toast={toast} setToast={setToast} errorToast={toastError} setErrorToast={setToastError} toastContent="Changes saved" />

      {/* Progress indicator */}
      <Box paddingInline="400">
        <BlockStack gap="200">
          <InlineStack align="space-between">
            <Text variant="bodySm" tone="subdued">
              Progress
            </Text>
            <Text variant="bodySm" tone="subdued">
              {expenses.length} remaining
            </Text>
          </InlineStack>
          <ProgressBar progress={progress} size="small" tone="primary" />
        </BlockStack>
      </Box>

      {/* Current expense card */}
      <ReceiptCard expense={expenses[0]} onComplete={handleNext} setToast={setToast} setErrorToast={setToastError} />
    </BlockStack>
  );
};
